import { ChevronDownIcon, FilterIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  FilterStatus,
  useBroadcastFilter,
} from '@/modules/broadcast/contexts/BroadcastFilterContext';

export const Toolbar = () => {
  const { t } = useTranslation();
  const { status, onStatusChange } = useBroadcastFilter();

  const setStatusFilter = (value: FilterStatus) => {
    onStatusChange(value);
  };

  const getFilterLabel = () => {
    switch (status) {
      case 'all':
        return t('broadcasts.status.all');
      case 'sent':
        return t('broadcasts.status.sent');
      case 'draft':
        return t('broadcasts.status.draft');
      case 'ready':
        return t('broadcasts.status.ready');
      default:
        return t('broadcasts.status.all');
    }
  };

  return (
    <div className="mb-4 flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Button variant="outline-neutral" size="sm" className="h-10 py-4" asChild type="button">
              <span>
                <FilterIcon className="mr-2 h-4 w-4" />
                {getFilterLabel()}
                <ChevronDownIcon className="ml-2 h-4 w-4" />
              </span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-40">
            <DropdownMenuRadioGroup
              value={status}
              onValueChange={(value) => setStatusFilter(value as FilterStatus)}
            >
              <DropdownMenuRadioItem value="all">
                {t('broadcasts.status.all')}
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="sent">
                {t('broadcasts.status.sent')}
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="draft">
                {t('broadcasts.status.draft')}
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="ready">
                {t('broadcasts.status.ready')}
              </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
